import { Dimensions, StyleSheet } from 'react-native';

const window_height = Dimensions.get('window').height - 10;

const styles = StyleSheet.create({
    contentItem: {
        width: '100%',
        height: 90,
        borderRadius: 10,
        padding: 10,
        flexDirection: 'row',
        marginBottom: 10,
        borderWidth: 1,
        borderColor: '#24909c',
        marginTop: 10
    },
    img: {
        width: 32,
        height: 30,
        marginTop: 10,
        marginLeft: 10,
    },
    imgModal: {
        width: 52,
        height: 50,
        marginHorizontal: "auto"
    },
    textsItem: {
        marginLeft: 20
    },
    infoTransactions: {
        position: "relative",
        flexDirection: 'column',
        justifyContent: 'flex-start'
    },
    titleTransactions: {
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 2
    },
    infosTransactions: {
        fontSize: 11,
        color: '#666',
        fontWeight: '700'
    },
    dateTransactions: {
        fontSize: 12,
    },
    valueTransactions: {
        fontSize: 14,
        color: "#999",
    },
    iconGo: {
        position: 'absolute',
        right: 10,
        marginTop: 20
    },
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 22,
        backgroundColor: "#222",
        opacity: 1,
    },
    modalCenteredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    closeModal: {
        marginLeft: "auto",
        marginRight: -10,
        marginTop: -5
    },
    share: {
        marginRight: "auto",
        marginLeft: -10,
        marginTop: -5
    },
    modalView: {
        width: "auto",
        marginTop: 20,
        backgroundColor: '#ffffff',
        borderRadius: 20,
        paddingHorizontal: 35,
        paddingVertical: 15,
        alignItems: "center",
        overflow: 'hidden',
        shadowOpacity: 0.2,
        shadowColor: '#000',
        shadowRadius: 0,
        shadowOffset: {
            width: 0,
            height: 0
        }
    },
    button: {
        borderRadius: 20,
        padding: 10,
        elevation: 2
    },
    idContainer: {
        marginHorizontal: -35,
        marginBottom: -25,
        marginTop: 20
    },
    modalTitle: {
        fontWeight: "bold",
        textAlign: "center",
        fontSize: 16,
        marginBottom: 15
    },
    modalText: {
        width: "100%",
        backgroundColor: "#fff",
        marginVertical: 10,
        textAlign: "center",
        alignContent: "center",
    },
    whiteText: {
        color: "white",
        fontSize: 12
    },
    boldText: {
        fontWeight: "bold",
    },
    modalTextDate: {
        width: "100%",
        color: "#666",
        fontSize: 12,
        marginVertical: 10,
        textAlign: "center",
        alignContent: "center",
    },
    blueBackground: {
        borderWidth: 1,
        color: "#ffffff",
        marginLeft: -15
    }
});

export default styles;